import { GenerateInitialModuleState } from "seneca-common/features/module/module-types/types";
import { Content } from "seneca-common/features/module/module-types/worked-example/types";

import { Actions, actionTypes } from "./actions";
import { findNextTestedWord } from "./selectors";
import { ModuleState } from "./types";

export const initialiseState: GenerateInitialModuleState<
  Content,
  ModuleState
> = ({ content }) => {
  const { steps } = content;
  return {
    currentStepIndex: 0,
    attempting: null,
    skippedWords: steps.map(({ equation }) => {
      return equation.reduce((acc, word) => {
        if (typeof word !== "string" && word.testing) {
          return { ...acc, [word.word]: false };
        }

        return acc;
      }, {});
    })
  };
};

export default function reducer(
  state: ModuleState,
  action: Actions
): ModuleState {
  switch (action.type) {
    case actionTypes.setAttempting: {
      // @ts-ignore
      return { ...state, attempting: action.payload };
    }

    case actionTypes.incrementCurrentStepIndex: {
      const {
        content: { steps }
      } = action.payload as any;

      return {
        ...state,
        currentStepIndex: Math.min(state.currentStepIndex + 1, steps.length - 1)
      };
    }

    case actionTypes.markNextAppropriateWordAsSkipped: {
      const { score, content } = action.payload as any;

      const { skippedWords, attempting } = state;
      let stepIndex;
      let wordId;

      if (attempting) {
        stepIndex = attempting.stepIndex;
        wordId = attempting.wordId;
      } else {
        const nextTestedWord = findNextTestedWord(score, content, state);
        stepIndex = nextTestedWord.stepIndex;
        wordId = nextTestedWord.wordId;
      }

      return {
        ...state,
        attempting: null,
        currentStepIndex: stepIndex,
        skippedWords: [
          ...skippedWords.slice(0, stepIndex),
          { ...skippedWords[stepIndex], [wordId]: true },
          ...skippedWords.slice(stepIndex + 1)
        ]
      };
    }

    default: {
      throw new Error(
        `Worked example module-state reducer, action type ${action.type} not recognised`
      );
    }
  }
}
